__turbopack_context__.v({
  "cta": "ParagraphHeroCta-module__yJzDBW__cta",
  "ctaPrimary": "ParagraphHeroCta-module__yJzDBW__ctaPrimary",
  "ctaSecondary": "ParagraphHeroCta-module__yJzDBW__ctaSecondary",
  "desc": "ParagraphHeroCta-module__yJzDBW__desc",
  "eyebrow": "ParagraphHeroCta-module__yJzDBW__eyebrow",
  "eyebrowLine": "ParagraphHeroCta-module__yJzDBW__eyebrowLine",
  "hero": "ParagraphHeroCta-module__yJzDBW__hero",
  "highlight": "ParagraphHeroCta-module__yJzDBW__highlight",
  "highlightBody": "ParagraphHeroCta-module__yJzDBW__highlightBody",
  "highlightIcon": "ParagraphHeroCta-module__yJzDBW__highlightIcon",
  "highlightText": "ParagraphHeroCta-module__yJzDBW__highlightText",
  "highlightTitle": "ParagraphHeroCta-module__yJzDBW__highlightTitle",
  "highlights": "ParagraphHeroCta-module__yJzDBW__highlights",
  "stat": "ParagraphHeroCta-module__yJzDBW__stat",
  "statLabel": "ParagraphHeroCta-module__yJzDBW__statLabel",
  "statValue": "ParagraphHeroCta-module__yJzDBW__statValue",
  "stats": "ParagraphHeroCta-module__yJzDBW__stats",
  "subtitle": "ParagraphHeroCta-module__yJzDBW__subtitle",
  "title": "ParagraphHeroCta-module__yJzDBW__title",
});
